import React, { FunctionComponent, useMemo, useState } from 'react';
import { Select } from 'antd';
import { useRequest } from 'ahooks';
import { getCompanyList, queryCompanyType, getResourceListBySupplierId } from './service';
import {
  LOCAL_COMPANY,
  LOCAL_COMPANY_TYPE,
  WINDOW_MENU_PERMISSIONS,
  WINDOW_FUNC_PERMISSIONS,
  WINDOW_PERMISSIONS_EVENT,
  MENU_TYPE_VALUE,
  FUNC_TYPE_VALUE,
} from '@/util/constants';
const CompanySelect: FunctionComponent = () => {
  const [companyListOption, setCompanyListOption] = useState<{ label: string; value: string }[]>();
  const [companyId, setCompanyId] = useState<string>();

  /** 可以展示桩企选择的路由 */
  const hasSupplierSelectRoutes = ['/operate.html#/devops'];

  const isShow = useMemo(() => hasSupplierSelectRoutes.some(path => location.href.includes(path)), [location]);

  /** 请求桩企列表 */
  const companyReq = useRequest(getCompanyList, {
    ready: isShow && !companyListOption,
    async onSuccess(res: any) {
      if (res?.length) {
        setCompanyListOption(res?.map(item => ({ label: item.supplierName, value: item.supplierId })));
        const localCompanyId = localStorage.getItem(LOCAL_COMPANY);
        if (res.some(item => item.supplierId === localCompanyId)) {
          setCompanyId(localCompanyId);
        } else {
          await setCompanyInfo(res[0].supplierId);
          setCompanyId(res[0].supplierId);
        }
      }
    },
  });

  /** 请求资源列表 */
  const { run: runResourceList } = useRequest(getResourceListBySupplierId, {
    ready: !!companyId,
    onSuccess(res) {
      const menu = [],
        func = [];
      res?.permissions?.forEach(item => {
        if (item.type === MENU_TYPE_VALUE) {
          menu.push(item.code);
        } else if (item.type === FUNC_TYPE_VALUE) {
          func.push(item.code);
        }
      });
      localStorage.setItem(WINDOW_MENU_PERMISSIONS, JSON.stringify(menu));
      localStorage.setItem(WINDOW_FUNC_PERMISSIONS, JSON.stringify(func));
      window.dispatchEvent(new CustomEvent(WINDOW_PERMISSIONS_EVENT));
    },
    onError(e) {
      localStorage.removeItem(WINDOW_MENU_PERMISSIONS);
      localStorage.removeItem(WINDOW_FUNC_PERMISSIONS);
    },
  });

  function setCompanyInfo(companyId: string) {
    return queryCompanyType({ companyId }).then(res => {
      // 更新公司id和公司类型
      const company = companyReq?.data?.find(company => company.supplierId === companyId);
      localStorage.setItem(LOCAL_COMPANY, companyId);
      const companyInfo = {
        ...company,
        isQuickStraight: Boolean(res.accessType === 1),
        isReformer: res.manufactureType === 1,
      };
      localStorage.setItem(LOCAL_COMPANY_TYPE, JSON.stringify(companyInfo));
    });
  }

  async function handleChange(v: string) {
    await setCompanyInfo(v);
    await runResourceList();
    history.go(0);
  }

  return isShow ? (
    <Select
      allowClear
      value={companyId}
      onChange={handleChange}
      style={{ width: 240, marginRight: 20 }}
      options={companyListOption}
      showSearch
      showArrow
      filterOption={(input, option) => option.label.toString().includes(input)}
    />
  ) : null;
};

export default CompanySelect;
